import { useContext } from "react";

// import GlobalContext                from "../isp._comun/contexto/GlobalContext";

import * as TipoDeError from "../../services/Errores";
import { NotificacionToastDeError } from "./widgets/notificacionesToast/NotificacionesToast";
import CodigoDeError from "./CodigosDeErrorDeRespuestas.json";
import DataDeRespuestas_Comun from "./DataEstaticaDeRespuestas.json";

const CrearHandlerDeErroresComunesDeComando = (notificar) => {
    // const { notificar } = useContext(GlobalContext);

    return (error) => {
        if (error instanceof TipoDeError.ErrorCancelacion) {
            return;
        }
        if (error instanceof TipoDeError.ErrorTecnico) {
            let nombreDeError = error.constructor.name;
            notificar(
                new NotificacionToastDeError(
                    DataDeRespuestas_Comun[nombreDeError].titulo,
                    DataDeRespuestas_Comun.labelCodigoError,
                    CodigoDeError[nombreDeError],
                    DataDeRespuestas_Comun[nombreDeError].descripcion
                )
            );
            return;
        }
        throw error;
    };
};

export default CrearHandlerDeErroresComunesDeComando;
